module.exports = __webpack_public_path__ + "img/napravlen-21.44e2557b.png";